import { Grid, Typography } from "@mui/material";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { useGetPurchaseCategory } from "./API/api";
import { Card } from "components/ui";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useGlobalContext } from "context/GlobalContext";
import SortContext from "context/SortContext";
import LoadingSmallCard from "components/ui/Skeleton/LoadingSmallCard";
import { useQuery } from "@tanstack/react-query";

function CategoryPurchase() {
  const [loading, setLoding] = useState(true);
  const [categories, setCategories] = useState([]);
  const { clientId, purchase } = useParams();
  let navigate = useNavigate();
  const { setFilterChangeCount, setDisplayCount, setFilterChangeDesignCount, setSearchResultCount, setSearchSuffix, dynamicfilterCount, filterChangeCount, filterChangeDesignCount } =
    useGlobalContext();
  const { setSortOptions } = useContext(SortContext);

  //API
  const { data, isLoading, error } = useGetPurchaseCategory({
    clientCode: clientId,
  });

  useEffect(() => {
    if (data) {
      setCategories(data.data);
    }
  }, [data]);

  useEffect(() => {
    if (dynamicfilterCount) {
      setFilterChangeCount(data?.totalCount);
      setFilterChangeDesignCount(data?.totalDesigncount);
      setSearchResultCount(0);
    } else {
      setSearchResultCount(0);
      setFilterChangeCount(filterChangeCount);
      setFilterChangeDesignCount(data?.totalDesigncount);
    }
    setDisplayCount(true);
    setSearchSuffix("Designs");

    return () => {
      setSearchResultCount(0);
      setFilterChangeCount(0);
      setFilterChangeDesignCount(0);
      setDisplayCount(false);
      setSearchSuffix("");
    };
  }, [categories]);

  useEffect(() => {
    setSortOptions(["a", "b", "c"]);
    return () => {
      setSortOptions([]);
    };
  }, []);

  const handleCategoryClick = (categoryName) => {
    navigate(`${encodeURIComponent(categoryName)}`);
  };

  if (isLoading) {
    return <LoadingSmallCard count={20} />;
  }

  if (error) {
    return <p>Error found</p>;
  }

  return (
    <div style={{ color: "yellow" }}>
      <Grid
        container
        className="Grid-padding"
        direction="row"
        sx={{
          flex: "1 1 1",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          gap: "30px",
          rowGap: "32px",
          maxHeight: "78vh",
          overflow: "auto",
          scrollbarWidth: "none",
        }}
      >
        {categories?.map((category) => {
          return (
            <Grid item onClick={() => handleCategoryClick(category?.categoryName)}>
              <Card
                style={{
                  minWidth: "290px",
                  maxWidth: "290px",
                  height: 62,
                  borderRadius: "5px",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                <Typography mr={"auto"} fontSize={"20px"} fontWeight={400} fontFamily={"Karla"}>
                  {category.categoryName}
                </Typography>
                <Typography ml={"auto"} fontSize={"20px"} fontWeight={400} fontFamily={"Karla"}>
                  {category.count}
                </Typography>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
}

export default CategoryPurchase;
